export const ORGANIZATION_MESSAGES = {
  NOT_FOUND: 'No organization records were found',
};


// WEBPACK FOOTER //
// ./src/constants/organizationMessages.js